import { useEffect } from "react";
import socket from "../utilities/socket";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../utilities/constant";
import AsyncStorage from "@react-native-async-storage/async-storage";

function useSocket(agentId) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!agentId) return;

    console.log("Initializing socket for:", agentId);

    socket.off("connect");
    socket.off("force_logout");
    socket.off("disconnect");
    socket.off("connect_error");

    // connect event
    socket.on("connect", () => {
      console.log("Connected:", socket.id);

      // join ONLY after connect
      socket.emit("join", { agentId });
    });

    // error handling
    socket.on("connect_error", (err) => {
      console.log("Connection error:", err.message);
    });

    // force logout
    socket.on("force_logout", async () => {
      console.log("Force logout received");

      await AsyncStorage.clear();

      socket.disconnect();

      navigate(`/${ROUTES.LOGIN}`);
    });

    // disconnect log
    socket.on("disconnect", (reason) => {
        console.log("Socket disconnected:", reason);
    });

    // connect socket (only if not already)
    if (!socket.connected) {
      socket.connect();
    }

    socket.on("reconnect_attempt", () => {
    console.log("Reconnecting...");
    });

    socket.on("reconnect", () => {
    console.log("Reconnected");
    });

    socket.on("reconnect_failed", () => {
    console.log("Reconnect failed");
    });

    return () => {
      socket.off("connect");
      socket.off("force_logout");
      socket.off("disconnect");
      socket.off("connect_error");
    };
  }, [agentId, navigate]);

  useEffect(() => {
    if (!agentId) return;
    
    const interval = setInterval(() => {
      // console.log('Frontend HeartBeat');
      socket.emit("heartbeat", { agentId });
    }, 10000);

    return () => clearInterval(interval);
  }, [agentId]);
}

export default useSocket;